// React
import React from "react";

// Bootstrap
import { Button, Spinner } from "react-bootstrap";

// Glyphies
import Glyphicon from "glyphicons";

export default function LoaderButton({
  isLoading,
  className = "",
  disabled = false,
  ...props
}) {
  return (
    <Button
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true" />}
      {props.children}
    </Button>
  );
}
